import { ref, Ref } from 'vue'
import { CdaConsent, defaultCdaConsent } from '@/types/CdaConsent'

/** CDA opt-in flags (Selligent via CRM). Auth still uses consent.email as subscribe_newsletter. */
const isSubscribeNewsletter: Ref<CdaConsent> = ref(defaultCdaConsent())

export default isSubscribeNewsletter
